"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      colors = _useTheme.colors,
      spacing = _useTheme.spacing,
      boxShadow = _useTheme.boxShadow;

  return {
    list: {
      minWidth: spacing(28),
      maxHeight: "calc(100vh - ".concat(spacing(8), ")"),
      overflow: 'auto',
      borderRadius: spacing(2),
      boxShadow: boxShadow('shadow', 4),
      backgroundColor: colors.white,
      boxSizing: 'content-box',
      outline: 'none',
      width: '100%',
      margin: 0,
      padding: 0,
      position: 'relative',
      listStyle: 'none'
    }
  };
};

__signature__(useStyles, "useTheme{{ colors, spacing, boxShadow }}", function () {
  return [_useTheme2["default"]];
});

var Menu = function Menu(props, ref) {
  var _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? -1 : _props$tabIndex,
      children = props.children,
      other = (0, _objectWithoutProperties2["default"])(props, ["tabIndex", "children"]);
  var classes = useStyles();
  return (0, _core.jsx)("ul", (0, _extends2["default"])({
    ref: ref,
    css: classes.list,
    role: "listbox",
    tabIndex: tabIndex
  }, other), children);
};

__signature__(Menu, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = (0, _react.forwardRef)(Menu);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/Menu/index.tsx");
  reactHotLoader.register(Menu, "Menu", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/Menu/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/Menu/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();